import { RSAA } from 'redux-api-middleware';
import { Dispatch } from 'redux';
import { TGetRootState, TAsyncDispatchResult } from 'types/shared';

const REQUEST = 'opus/consulData/REQUEST';
const SUCCESS = 'opus/consulData/SUCCESS';
const FAILURE = 'opus/consulData/FAILURE';

type ConsulActionTypes = typeof REQUEST | typeof SUCCESS | typeof FAILURE;

export interface IConsulData {
  ExportToPDF_Streaming: boolean;
  PriorityPlaylistOnlyForBeta: boolean;
  BetaGroupPriorityPlaylist: string[];
  RolesCanAnnotatePlaylistAsPriority: string[];
  ON_linkUrl: string;
  isOpusNotifierOn: boolean;
}

export interface IConsulState {
  pending: boolean;
  fulfilled: boolean;
  error: boolean;
  reason: any;
  data: IConsulData | undefined;
}

interface IConsulAction {
  type: ConsulActionTypes;
  payload: IConsulData;
}

const initialState: IConsulState = {
  pending: false,
  fulfilled: false,
  error: false,
  reason: null,
  data: undefined,
};

function reducer(
  state: IConsulState = initialState,
  action: IConsulAction
): IConsulState {
  switch (action.type) {
    case REQUEST: {
      return {
        ...state,
        pending: true,
        fulfilled: false,
        error: false,
      };
    }
    case SUCCESS: {
      return {
        ...state,
        pending: false,
        fulfilled: true,
        error: false,
        data: action.payload,
      };
    }
    case FAILURE: {
      return {
        ...state,
        pending: false,
        fulfilled: false,
        error: true,
        reason: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}

function loadConsulSettings(): TAsyncDispatchResult {
  return async function (
    dispatch: Dispatch,
    getState: TGetRootState
  ): Promise<any> {
    const { consulEnvData } = getState();

    return await dispatch({
      [RSAA]: {
        bailout: consulEnvData.pending || consulEnvData.fulfilled,
        types: [
          REQUEST,
          {
            type: SUCCESS,
            payload: async function payload(
              action: IConsulAction,
              state: IConsulState,
              res: any
            ): Promise<any> {
              const json = await res.json();
              return json;
            },
          },
          FAILURE,
        ],
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        method: 'GET',
        endpoint: '/getConsulData/env_parameters',
      },
    });
  };
}

export { loadConsulSettings };
export default reducer;
